document.addEventListener('click', function (e) {
  const teeBtn = e.target.closest('#teeAtcButton');
  if (!teeBtn) return;

  // Wait for Teeinblue to finish adding to cart
  waitForCartChange(openShopifyDrawer);
});


function waitForCartChange(callback) {
  let initialCount = null;

  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      initialCount = cart.item_count;

      const interval = setInterval(() => {
        fetch('/cart.js')
          .then(r => r.json())
          .then(newCart => {
            if (newCart.item_count > initialCount) {
              clearInterval(interval);
              callback();
            }
          });
      }, 300);
    });
}


let drawerClicked = false;

function openShopifyDrawer() {
  if (drawerClicked) return; // prevent bouncing
  drawerClicked = true;

  const cartBtn =
    document.querySelector('.header__icon--cart') ||
    document.querySelector('[data-cart-toggle]') ||
    document.querySelector('a[href="/cart"]');

  if (cartBtn) {
    cartBtn.click(); // open drawer
    // reset after a short delay so it can be triggered again later
    setTimeout(() => {
      drawerClicked = false;
    }, 1000); // 1s is usually enough for animation to finish
  } else {
    console.warn('Cart button not found!');
  }
}



console.log("trest")